/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { useRouteByName } from '@jira/platform__utils-router/src/index.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { generatePath, useRouter } from '@atlassian/react-resource-router';

export const DashboardRedirect = (): React.JSX.Element => {
	const [
		{
			query,
			location: { hash },
		},
	] = useRouter();
	const { path } = useRouteByName('dashboard-view') ?? {};
	const { path: lastVisitedPath } = useRouteByName('dashboard-last-visited') ?? {};
	if (path == null || lastVisitedPath == null) {
		throw new Error('Dashboard view route not found');
	}

	const { selectPageId: id } = query;

	const generatedPath = /^\d+$/.test(id)
		? generatePath(path, { dashboardId: id })
		: lastVisitedPath;

	const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
	const pathWithQuery =
		maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;

	return <ScreenRedirect to={pathWithQuery} persistSearchParams={false} />;
};
